"use strict";
exports.__esModule = true;
exports.EventEmitter = void 0;
var EventEmitter = /** @class */ (function () {
    function EventEmitter(catchHandler) {
        this._events = Object.create(null);
        this.catchHandler = catchHandler || (function () { return undefined; });
    }
    EventEmitter.prototype.hasListeners = function (eventName) {
        return !!(this._events[eventName] && this._events[eventName].length);
    };
    EventEmitter.prototype.getActiveEvents = function () {
        var _this = this;
        return Object.keys(this._events).filter(function (name) { return _this.hasListeners(name); });
    };
    EventEmitter.prototype.trigger = function (eventName, params) {
        var _this = this;
        if (this._events[eventName]) {
            this._events[eventName].slice().forEach(function (data) {
                try {
                    data.handler.call(data.context, params);
                }
                catch (e) {
                    _this.catchHandler(e);
                }
                if (data.once) {
                    _this.off(eventName, data.handler);
                }
            });
            if (!this._events[eventName].length) {
                delete this._events[eventName];
            }
        }
    };
    EventEmitter.prototype.on = function (eventName, handler, context) {
        this._on(eventName, handler, context, false);
    };
    EventEmitter.prototype.once = function (eventName, handler, context) {
        this._on(eventName, handler, context, true);
    };
    EventEmitter.prototype.off = function (arg1, arg2) {
        var _this = this;
        var eventName = typeof arg1 === 'string' ? arg1 : null;
        var handler = typeof arg2 === 'function' ? arg2 : typeof arg1 === 'function' ? arg1 : null;
        if (!eventName) {
            Object.keys(this._events).forEach(function (eventName) {
                _this.off(eventName, handler);
            });
            return void 0;
        }
        if (!handler) {
            delete this._events[eventName];
            return void 0;
        }
        if (eventName in this._events) {
            var index = this._events[eventName].map(function (item) { return item.handler; }).indexOf(handler);
            this._events[eventName].splice(index, 1);
        }
    };
    EventEmitter.prototype._on = function (eventName, handler, context, once) {
        if (!this._events[eventName]) {
            this._events[eventName] = [];
        }
        this._events[eventName].push({ handler: handler, context: context, once: once });
    };
    return EventEmitter;
}());
exports.EventEmitter = EventEmitter;
